module.exports = __webpack_public_path__ + "img/service.32c03de4.png";